<div class="text-editor-panel">
  <!-- Header -->
  <div class="panel-header">
    <h3 class="panel-title">Hero Header Section</h3>
    <button class="close-btn" (click)="onClose()">
      <img src="assets/images/website-builder/close-icon.svg" alt="Close" width="12" height="12">
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <div class="tabs">
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'content'"
        (click)="onTabChange('content')">
        <img src="assets/images/website-builder/pencil-icon.svg" alt="Content" width="13" height="13">
        Content
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'layout'"
        (click)="onTabChange('layout')">
        <img src="assets/images/website-builder/layout-board-icon.svg" alt="Layout" width="14" height="14">
        Layout
      </button>
    </div>
  </div>

  <!-- Content Tab -->
  <div class="panel-content" *ngIf="activeTab === 'content'">
    <!-- Heading & Paragraph Section -->
    <app-section-accordion 
      title="Heading & Paragraph"
      [isExpanded]="isSectionExpanded('heading')"
      (toggle)="toggleSection('heading')">
      
      <!-- Heading -->
      <div class="input-group">
        <label class="input-label">Heading</label>
        <app-text-editor
          [value]="data.heading"
          [style]="data.titleStyle || {}"
          placeholder="Enter heading text..."
          (valueChange)="onHeadingChange($event)"
          (styleChange)="onHeadingStyleChange($event)">
        </app-text-editor>
      </div>

      <!-- Paragraph -->
      <div class="input-group">
        <label class="input-label">Paragraph</label>
        <textarea 
          class="paragraph-input"
          [value]="data.paragraph"
          (input)="onParagraphChange($any($event.target).value)"
          placeholder="Enter paragraph text...">
        </textarea>
      </div>
    </app-section-accordion>

    <!-- Media Section -->
    <app-section-accordion 
      title="Media"
      [isExpanded]="isSectionExpanded('media')"
      (toggle)="toggleSection('media')">
        <!-- Image Upload Section -->
        <div class="image-upload-section">
          <div class="image-preview-container">
            <div class="image-preview" [style.background-image]="'url(' + (data.image?.src || '') + ')'">
              <div class="image-overlay" *ngIf="!data.image?.src">
                <div class="upload-placeholder">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              <!-- Upload loading overlay -->
              <div class="image-overlay" *ngIf="isUploadingImage" style="background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center;">
                <div style="color: white; text-align: center;">
                  <div style="margin-bottom: 8px;">Uploading...</div>
                  <div style="font-size: 12px;">Please wait</div>
                </div>
              </div>
              <!-- Upload error message -->
              <div class="image-overlay" *ngIf="uploadError && !isUploadingImage" style="background: rgba(220, 38, 38, 0.9); display: flex; align-items: center; justify-content: center;">
                <div style="color: white; text-align: center; padding: 8px;">
                  <div style="font-size: 12px;">{{ uploadError }}</div>
                </div>
              </div>
            </div>
            <button class="replace-btn" (click)="onReplaceImage()" [disabled]="isUploadingImage">
              {{ isUploadingImage ? 'Uploading...' : 'Replace' }}
            </button>
          </div>
          
          <div class="file-info">
            <div class="file-info-item">
              <span class="file-info-text">Accepted formats - .png, .jpg, .jpeg, .mp4</span>
              <div class="divider"></div>
              <span class="file-info-text">Max file size - 5MB</span>
            </div>
          </div>
        </div>

        <!-- Image Settings -->
        <div class="image-settings">
          <label class="settings-label">How should the image look?</label>
          <div class="custom-dropdown-container">
            <button 
              class="custom-dropdown-button image-fit-dropdown-button"
              [class.active]="showImageFitDropdown"
              (click)="toggleImageFitDropdown()">
              <span class="dropdown-selected-text">{{ getImageFitLabel() }}</span>
              <img 
                src="assets/images/website-builder/chevron-down-icon.svg" 
                alt="Dropdown" 
                width="8" 
                height="5" 
                class="dropdown-chevron"
                [class.rotated]="showImageFitDropdown">
            </button>
            <div 
              class="custom-dropdown-menu image-fit-dropdown-menu" 
              [class.dropdown-above]="imageFitDropdownAbove"
              *ngIf="showImageFitDropdown">
              <button 
                class="dropdown-option"
                [class.selected]="data.image?.scaletype === 'fill'"
                (click)="onImageFitChange('fill')">
                Fill
              </button>
              <button 
                class="dropdown-option"
                [class.selected]="data.image?.scaletype === 'fit'"
                (click)="onImageFitChange('fit')">
                Fit
              </button>
              <button 
                class="dropdown-option"
                [class.selected]="data.image?.scaletype === 'stretch'"
                (click)="onImageFitChange('stretch')">
                Stretch
              </button>
            </div>
          </div>
        </div>
    </app-section-accordion>

    <!-- Button Section -->
    <app-section-accordion 
      title="Button"
      [isExpanded]="isSectionExpanded('button')"
      (toggle)="toggleSection('button')">
        <!-- Button Text Input -->
        <div class="button-input-group">
          <label class="input-label">Add the button text here*</label>
          <div class="input-container">
            <input 
              type="text" 
              class="button-text-input"
              [(ngModel)]="data.buttonText"
              (input)="onButtonTextChange($any($event.target).value)"
              placeholder="Book Washssss">
          </div>
        </div>

        <!-- Button Navigation Dropdown -->
        <div class="button-input-group">
          <label class="input-label">When clicked, go to page*</label>
          <div class="custom-dropdown-container">
            <button 
              class="custom-dropdown-button navigation-dropdown-button"
              [class.active]="showNavigationDropdown"
              (click)="toggleNavigationDropdown()">
              <span class="dropdown-selected-text">{{ getNavigationLabel() }}</span>
              <img 
                src="assets/images/website-builder/chevron-down-icon.svg" 
                alt="Dropdown" 
                width="8" 
                height="5" 
                class="dropdown-chevron"
                [class.rotated]="showNavigationDropdown">
            </button>
            <div 
              class="custom-dropdown-menu navigation-dropdown-menu" 
              [class.dropdown-above]="navigationDropdownAbove"
              *ngIf="showNavigationDropdown">
              <button 
                class="dropdown-option"
                [class.selected]="data.buttonNavigation === 'homepage'"
                (click)="onButtonNavigationChange('homepage')">
                Homepage
              </button>
              <button 
                class="dropdown-option"
                [class.selected]="data.buttonNavigation === 'express-washes'"
                (click)="onButtonNavigationChange('express-washes')">
                Express Washes
              </button>
              <button 
                class="dropdown-option"
                [class.selected]="data.buttonNavigation === 'express-detail'"
                (click)="onButtonNavigationChange('express-detail')">
                Express Detail
              </button>
              <button 
                class="dropdown-option"
                [class.selected]="data.buttonNavigation === 'fleets'"
                (click)="onButtonNavigationChange('fleets')">
                Fleets
              </button>
              <button 
                class="dropdown-option"
                [class.selected]="data.buttonNavigation === 'coupons'"
                (click)="onButtonNavigationChange('coupons')">
                Coupons
              </button>
            </div>
          </div>
        </div>
    </app-section-accordion>

    <!-- Background Section -->
    <app-section-accordion 
      title="Background"
      [isExpanded]="isSectionExpanded('background')"
      (toggle)="toggleSection('background')">
        <!-- Color Swatches -->
        <div class="color-palette">
          <div class="color-list">
            <!-- Purple Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#5E19A1'" (click)="onBackgroundColorChange('#5E19A1')">
              <div class="color-swatch" style="background-color: #5E19A1;"></div>
              <span class="color-code">#5E19A1</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#5E19A1'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Orange Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#FF9736'" (click)="onBackgroundColorChange('#FF9736')">
              <div class="color-swatch" style="background-color: #FF9736;"></div>
              <span class="color-code">#FF9736</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#FF9736'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Green Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#079271'" (click)="onBackgroundColorChange('#079271')">
              <div class="color-swatch" style="background-color: #079271;"></div>
              <span class="color-code">#079271</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#079271'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Blue Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#1B5BFF'" (click)="onBackgroundColorChange('#1B5BFF')">
              <div class="color-swatch" style="background-color: #1B5BFF;"></div>
              <span class="color-code">#1B5BFF</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#1B5BFF'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
          
          <!-- Divider -->
          <div class="color-divider"></div>
          
          <!-- Add Color Button -->
          <div class="add-color-section">
            <div class="color-item add-color" (click)="onAddColor()">
              <div class="color-swatch add-color-swatch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M6 1V11M1 6H11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="color-code">Add Color</span>
            </div>
          </div>

          <!-- Custom Colors (dynamically added) -->
          <div class="color-item" 
               *ngFor="let customColor of customColors; trackBy: trackByIndex" 
               [class.selected]="data.backgroundColor === customColor" 
               (click)="openColorPicker(customColor)">
            <div class="color-swatch" [style.background-color]="customColor"></div>
            <span class="color-code">{{ customColor }}</span>
            <div class="checkmark" *ngIf="data.backgroundColor === customColor">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
    </app-section-accordion>
  </div>

  <!-- Color Picker Modal -->
  <div class="color-picker-overlay" *ngIf="isColorPickerOpen" (click)="closeColorPicker()">
    <div class="color-picker-modal" (click)="$event.stopPropagation()">
      <div class="color-picker-header">
        <h3 class="color-picker-title">Color picker</h3>
        <button class="color-picker-close" (click)="closeColorPicker()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div class="color-picker-content">
        <chrome-picker 
          [(color)]="currentPickerColor" 
          (colorChange)="onColorPickerChange()">
        </chrome-picker>
      </div>

    </div>
  </div>

  <!-- Layout Tab -->
  <div class="panel-content" *ngIf="activeTab === 'layout'">
    <div class="layout-selector">
      <!-- Layout 1: Text Left, Image Right -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '1'"
           (click)="onLayoutChange('1')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 1</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '1'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="data?.backgroundColor || '#EBF0FF'">
          <app-hero-layout-1-preview
            [data]="getHeroLayout1Data()"
            [headingColor]="getHeadingColor()"
            [paragraphColor]="getParagraphColor()"
            [headingFont]="getHeadingFont()"
            [bodyFont]="getBodyFont()"
            [primaryColor]="getPrimaryColor()"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-hero-layout-1-preview>
        </div>
      </div>

      <!-- Layout 2: Image Top, Text Centered -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '2'"
           (click)="onLayoutChange('2')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 2</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '2'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="data?.backgroundColor || '#EBF0FF'">
          <app-hero-layout-2-preview
            [data]="getHeroLayout1Data()"
            [headingColor]="getHeadingColor()"
            [paragraphColor]="getParagraphColor()"
            [headingFont]="getHeadingFont()"
            [bodyFont]="getBodyFont()"
            [primaryColor]="getPrimaryColor()"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-hero-layout-2-preview>
        </div>
      </div>

      <!-- Layout 3: Image Left, Text Right -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '3'"
           (click)="onLayoutChange('3')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 3</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '3'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="data?.backgroundColor || '#EBF0FF'">
          <app-hero-layout-3-preview
            [data]="getHeroLayout1Data()"
            [headingColor]="getHeadingColor()"
            [paragraphColor]="getParagraphColor()"
            [headingFont]="getHeadingFont()"
            [bodyFont]="getBodyFont()"
            [primaryColor]="getPrimaryColor()"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-hero-layout-3-preview>
        </div>
      </div>

      <!-- Layout 4: Text at Top with Background Image (Dark/Modern Theme Style) -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '4'"
           (click)="onLayoutChange('4')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 4</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '4'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="data?.backgroundColor || '#000000'">
          <app-hero-layout-4-preview
            [data]="getHeroLayout1Data()"
            [headingColor]="getHeadingColor()"
            [paragraphColor]="getParagraphColor()"
            [headingFont]="getHeadingFont()"
            [bodyFont]="getBodyFont()"
            [primaryColor]="getPrimaryColor()"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-hero-layout-4-preview>
        </div>
      </div>

      <!-- Layout 5: Text Vertically Centered with Background Image -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '5'"
           (click)="onLayoutChange('5')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 5</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '5'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="data?.backgroundColor || '#000000'">
          <app-hero-layout-5-preview
            [data]="getHeroLayout1Data()"
            [headingColor]="getHeadingColor()"
            [paragraphColor]="getParagraphColor()"
            [headingFont]="getHeadingFont()"
            [bodyFont]="getBodyFont()"
            [primaryColor]="getPrimaryColor()"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-hero-layout-5-preview>
        </div>
      </div>

      <!-- Layout 6: Text Vertically Bottom with Background Image -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '6'"
           (click)="onLayoutChange('6')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 6</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '6'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="data?.backgroundColor || '#000000'">
          <app-hero-layout-6-preview
            [data]="getHeroLayout1Data()"
            [headingColor]="getHeadingColor()"
            [paragraphColor]="getParagraphColor()"
            [headingFont]="getHeadingFont()"
            [bodyFont]="getBodyFont()"
            [primaryColor]="getPrimaryColor()"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-hero-layout-6-preview>
        </div>
      </div>

      <!-- Layout 7: Modern Template Style - Full Background with Text on Left -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '7'"
           (click)="onLayoutChange('7')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 7</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '7'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="data?.backgroundColor || 'linear-gradient(135deg, #C5D5EA 0%, #E5EBF4 50%, #D4E0F0 100%)'">
          <app-hero-layout-7-preview
            [data]="getHeroLayout1Data()"
            [headingColor]="getHeadingColor()"
            [paragraphColor]="getParagraphColor()"
            [headingFont]="getHeadingFont()"
            [bodyFont]="getBodyFont()"
            [primaryColor]="getPrimaryColor()"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-hero-layout-7-preview>
        </div>
      </div>
    </div>
  </div>
</div>
